<div class="container">
  <div *ngIf="notificationModalUrl !== ''" [hidden]="!notificationsShown">
    <iframe id="notificationsIFrame" [src]="notificationModalUrl | safe"
            style="position: fixed; top: 0px; left: 0px; height: 100%; width: 100%; border: none; z-index: 99">
    </iframe>
  </div>
  <div id="header" class="main-header">
    <app-header></app-header>
    <app-nav-menu></app-nav-menu>
  </div>
  <div id="content" class="main-body">
    <router-outlet></router-outlet>
  </div>
  <div id="footer" class="main-footer">
    <app-footer></app-footer>
  </div>
</div>
